<template>
    <md-card>
        <md-card-content>
            <md-table
                    :value="queriedData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover"
            >
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Per page</label>
                        <md-select v-model="pagination.perPage" name="pages">
                            <md-option
                                    v-for="item in pagination.perPageOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                            >
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>

                    <md-field>
                        <md-input
                                type="search"
                                class="mb-3"
                                clearable
                                style="width: 200px"
                                placeholder="Search records"
                                v-model="searchQuery"
                                @input="$emit('searchLabourerTable', searchQuery)"
                        >
                        </md-input>
                    </md-field>
                </md-table-toolbar>

                <md-table-empty-state
                        md-label="No permission found"
                        :md-description="`No permission found for this '${search}' query. Try a different search term or attach new permission.`">
                    <md-button class="md-primary md-raised"
                               @click="$emit('addLabourerToSkill', skill.id)">
                        Assign Labourer to Skill {{skill.name}}
                    </md-button>
                </md-table-empty-state>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Number" md-sort-by="name">{{item.labourer_number}}</md-table-cell>
                    <md-table-cell md-label="Name" md-sort-by="name">{{item.name}}</md-table-cell>
                    <md-table-cell md-label="Status" md-sort-by="email">{{item.status}}</md-table-cell>
                    <md-table-cell md-label="Actions">
                        <md-button v-if="can('read-labourer')"
                                class="md-just-icon md-info md-simple"
                                @click.native="handleLike(item)">
                            <md-icon>search</md-icon>
                        </md-button>
                        <md-button
                                v-if="can('update-labourer')"
                                class="md-just-icon md-warning md-simple"
                                @click.native="handleEdit(item)">
                            <md-icon>dvr</md-icon>
                        </md-button>
                        <md-button v-if="can('update-skill')"
                                class="md-just-icon md-danger md-simple"
                                @click="$emit('removeLabourer', item)">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <div class="">
                <p class="card-category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
            </div>
            <pagination
                    class="pagination-no-border pagination-success"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
import { Pagination } from '@/components';
import Fuse from 'fuse.js';

export default {
    name: 'SkillLabourersTable',
    components: {
        Pagination
    },
    computed: {
        /** *
             * Returns a page from the searched data or the whole data. Search is performed in the watch section below
             */
        queriedData () {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total () {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        }
    },
    props: {
        tableData: {
            type: Array,
            default: () => {
            }
        },
        skill: {
            type: Object,
            default: () => {
            }
        }
    },
    data () {
        return {
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            footerTable: ['Name', 'Email', 'Age', 'Salary', 'Actions'],
            searchQuery: '',
            search: null,
            propsToSearch: ['name', 'email', 'age'],
            searchedData: [],
            fuseSearch: null
        };
    },
    methods: {
        customSort (value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleLike (item) {
            let id = item.id;
            if (typeof item.uuid !== 'undefined') {
                id = item.uuid;
            }
            this.$router.push({ name: 'View Labourer', params: { id } });
        },
        handleEdit (item) {
            let id = item.id;
            if (typeof item.uuid !== 'undefined') {
                id = item.uuid;
            }
            this.$router.push({ name: 'Edit Labourer', params: { id } });
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Skill', params: { id } });
        },

    },
    mounted () {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ['name', 'email'],
            threshold: 0.3
        });
    },
    watch: {
        /**
             * Searches through the table data by a given query.
             * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
             * @param value of the query
             */
        searchQuery (value) {
            let result = this.tableData;
            if (value !== '') {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        }
    }
};
</script>

<style scoped>

</style>
